import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { toUI } from '../../utility/mapStaticData';
import icons from '../../assets/icons';

import Trader from './Trader';

import * as tradersActions from './reducer';


import './Traders.css';

import DropdownField from '../../recordDetail/fields/DropdownField';
import AsyncDropdownField from '../../recordDetail/fields/AsyncDropdownField';

export class TradersComponent extends Component {
  static get propTypes() {
    return {
      fetching: PropTypes.bool,
      onFetch: PropTypes.func.isRequired,
      onFetchPotentialTraders: PropTypes.func.isRequired,
      setTraderActive: PropTypes.func.isRequired,
      removeTrader: PropTypes.func.isRequired,
      addTrader: PropTypes.func.isRequired,
      traders: PropTypes.array
    };
  }

  constructor(props) {
    super(props);
    props.onFetch();

    this.state = {
      traders: props.traders,
      newTrader: undefined,
      searchEmployees: true,
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      traders: props.traders
    });
  }

  render() {
    const { fetching } = this.props;
    const { traders } = this.state;

    return (
      <div className="AdminTraders">
        { fetching && <div className="fetching">Getting traders</div> }
        { traders && this.renderTraders(traders) }
        {this.renderAddTrader()}
      </div>
    );
  }

  renderTraders(traders) {
    const { setTraderActive, removeTrader } = this.props;
    return (<table className="Admin-table AdminTraders-table">
      <tbody>
        <tr>
          <th className="name">Trader</th>
          <th className="active">Active</th>
          <th className="delete">Delete</th>
        </tr>
        { traders.map(t => (
          <Trader
            trader={t}
            key={t.Id}
            onSetActive={isActive => setTraderActive(t, isActive)}
            onRemoveTrader={() => removeTrader(t)}
          />))}
      </tbody>
    </table>);
  }

  renderEmployeeSearchCheck() {
    const { searchEmployees } = this.state;

    const checkId = 'checkbox-search-employees';
    const checkImg = searchEmployees ? icons.blue.checkbox_on : icons.blue.checkbox_off;

    return (<div className="AdminTraders-search-employees">
      <input
        type="checkbox"
        checked={searchEmployees}
        onChange={event => this.setEmployeeSearch(event.target.checked)}
        id={checkId}
      /><label className="checkbox-search-employees-label" htmlFor={checkId}>
        <img className="checkImg" src={checkImg} alt="checkbox" />
        <span>Search from potential traders</span>
      </label>
    </div>);
  }

  setEmployeeSearch(searchEmployees) {
    this.setState({
      searchEmployees,
      newTrader: undefined
    });
  }

  renderSearchTrader() {
    const { newTrader } = this.state;

    return (
      <div className="FieldsContainer-group addTraderControl">
        <AsyncDropdownField
          name="potential-traders"
          label=""
          className="search-potential-traders"
          editing
          required
          placeholder="Search for new trader"
          value={newTrader}
          fetchAsyncData={input => this.onFetchPotentialTraders(input)}
          mapFn={toUI.adminPotentialTraders}
          onChange={newValue => this.onChangeNewTrader(newValue)}
          validationMessage={null}
        />
        {this.renderAddButton()}
      </div>);
  }

  renderCreateTrader() {
    const { newTrader } = this.state;
    return (
      <div className="FieldsContainer-group addTraderControl">
        <input
          type="text"
          placeholder="New Trader Email Address"
          className="AdminTrader-newtraderName"
          value={newTrader ? newTrader.Name : ''}
          onChange={event => this.updateCreateTraderName(event.target.value)}
        />
        {this.renderAddButton()}
      </div>);
  }

  updateCreateTraderName(inputText) {
    const newTrader = {
      Name: inputText,
      UserPrincipalName: 'N/A'
    };

    this.setState({ newTrader });
  }

  renderAddButton() {
    return (
      <input
        type="submit"
        className="AdminTraders-addtradersubmit btn btn-submit"
        value="Add"
        disabled={!this.validateNewTrader()}
      />);
  }

  renderAddTrader() {
    const { searchEmployees } = this.state;
    return (<form className="AdminTraders-addtrader" onSubmit={event => this.addNewTrader(event)}>
      <div className="addtrader-label">Add New Trader</div>
      <div className="select-from-employees">
        {this.renderEmployeeSearchCheck()}
      </div>
      {searchEmployees
        ? this.renderSearchTrader()
        : this.renderCreateTrader()}
    </form>);
  }

  onFetchPotentialTraders(value) {
    const { onFetchPotentialTraders } = this.props;

    return onFetchPotentialTraders(value);
  }

  onChangeNewTrader(newTrader) {
    this.setState({ newTrader });
  }

  addNewTrader(event) {
    const { addTrader } = this.props;
    const { newTrader } = this.state;
    event.preventDefault();

    addTrader(newTrader);
    this.setState({ newTrader: undefined });
  }

  validateNewTrader() {
    const { newTrader, traders } = this.state;
    const Name = newTrader ? newTrader.Name : undefined;
    if (!Name) {
      return false;
    }
    const name = Name.toLowerCase().trim();
    const index = traders.findIndex(t =>
      t.Name.toLowerCase().trim() === name);

    return !!newTrader && index === -1;
  }
}

const mapStateToProps = state => ({
  fetching: state.admin.traders.fetching,
  traders: state.admin.traders.traders
});

const mapDispatchToProps = (dispatch) => {
  const {
    fetchTradersIfNeeded,
    setTraderActive,
    addTrader,
    fetchPotentialTraders,
    removeTrader
  } = bindActionCreators(tradersActions, dispatch);

  return {
    onFetch: fetchTradersIfNeeded,
    onFetchPotentialTraders: fetchPotentialTraders,
    setTraderActive,
    addTrader,
    removeTrader
  };
};

const Traders = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TradersComponent));
export default Traders;



// WEBPACK FOOTER //
// ./src/admin/traders/Traders.js